import { guessPlacePaymentType, guessPlaceType, PRICE_TYPE_DONT_DISPLAY, PRICE_TYPE_PRICE_LEVEL } from "./utils";

class PlaceWrapper {
    constructor(place=null) {
        this.place = place;
    }
    set(place) {
        this.place = place;
        this._resetCachedValues()
        console.log('PlaceWrapper.set', this.place);
    }
    _resetCachedValues() {
        this._type = void(0);
        this._payment_type = void(0);
    }
    name() {
        return this.place?.name;
    }
    type() {
        if (!this._type) {
            this._type = guessPlaceType( (this.place?.types || []) ).toString();
        }
        return this._type;
    }
    payment_type() {
        if (!this._payment_type) {
            this._payment_type = guessPlacePaymentType(this.place?.types || []).toString();
        }
        return this._payment_type;
    }
    price_type() {
        return this.place?.price_level ? PRICE_TYPE_PRICE_LEVEL : PRICE_TYPE_DONT_DISPLAY;
    }
    latitude(precision=8) {
        return parseFloat(this.place?.geometry?.location?.lat().toFixed(precision));
    }
    longitude(precision=8) {
        return parseFloat(this.place?.geometry?.location?.lng().toFixed(precision));
    }
    price_level() { return this.place?.price_level; }
    address() { return this.place?.formatted_address; }
    phone() { return this.place?.phone || this.place?.international_phone_number; }
    website() { return this.place?.website; }
    schedule() { return this.place?.opening_hours?.periods; }
    photos(selectAll) {
        return (this.place?.photos || []).map(x => ({
            ...x, 
            selected: x.selected === void(0) ? selectAll : x.selected, 
            // Resolved by placeToLegacy; PlacePhoto.getUrl() is deprecated.
            src: x.src,
        }));
    }
    ratings() {
        return [{
            id: null,
            review_count: this.place?.user_ratings_total,
            star_rating: this.place?.rating,
            review_source_url: this.place?.url,
            review_source_name: 'Google',
            include_in_aggregate: false,
            entry_type: 'Totals',
        }]
    }

    // populateFormRefs(refs) {
    //     this._populateTextField(refs, 'display_name', this.name());
    //     this._populateSelectField(refs, 'type', this.type());
    // }

    // _populateTextField(refs, id, val) {
    //     if (refs[id].current) {
    //         console.log(`populateTextField: ${id} = ${val}`);
    //         refs[id].current.querySelector('input').value = val;
    //     }
    // }

    // _populateSelectField(refs, id, val) {
    //     if (refs[id].current) {
    //         console.log(`populateSelectField: ${id} = ${val}`);
    //         refs[id].current.querySelector('select').value = val;
    //     }
    // }
}

export default PlaceWrapper;
